import { TMatchingMode } from '../types';

export const modalTypes = {
    SIGNUP: 'signup',
    LOGIN: 'login',
    RESET_PASSWORD: 'reset_password',
};

export const jobModes = {
    EDIT: 'edit',
    DUPLICATE: 'duplicate',
    CREATE: 'create',
};

export const serviceTypes = {
    CONSTRUCTION: 'construction',
    DRIVER: 'driver',
    HOSPITALITY: 'hospitality',
    INDUSTRY: 'industry',
    OFFICE: 'office',
};

export const serviceNames = {
    CONSTRUCTION: 'Construction',
    DRIVER: 'Delivery',
    HOSPITALITY: 'Hospitality',
    INDUSTRY: 'Industrial',
    OFFICE: 'Office',
};

export const vehicleTypes = {
    MOTORCYCLE: 4,
    CAR: 2,
    VAN: 1,
    CLASS_1: 5,
    CLASS_2: 6,
    TONNE_7_5: 7,
    COACH: 8,
};

export const vehicleRoles = {
    // MOTORCYCLE: 'Motorcycle/Scooter', BER-823 - vehicle_type__is_active=False
    CAR: 'Car',
    VAN: 'Van',
    CLASS_1: 'Class 1',
    CLASS_2: 'Class 2',
    TONNE_7_5: '7.5 tonne',
    COACH: 'Bus/Coach',
};

export const constructionTypes = {
    GENERAL: 'CG',
    LABOURER: 'LA',
    CARPENTER: 'CA',
    ELECTRICIAN: 'EL',
    PLUMBER: 'PL',
    PLANT_OPERATOR: 'PO',
    BRICKLAYER: 'BL',
    PLASTERER: 'PS',
    SITE_MANAGER: 'SM',
    HANDYMAN: 'HM',
    SCAFFOLDER: 'SC',
    MULTI_TRADE: 'MT',
    PAINTER_DECORATOR: 'PD',
    GROUNDWORKER: 'GW',
    WELDER: 'WD',
    CONTRACTS_MANAGER: 'CM',
    BANKSMAN: 'BK',
    TILER: 'TL',
    ASBESTOS_WORKER: 'AW',
    PROJECT_MANAGER: 'PM',
    STEEL_FIXER: 'SF',
    QUANTITY_SURVEYOR: 'QS',
};

export const constructionRoles = {
    GENERAL: 'Construction General',
    LABOURER: 'Labourer',
    CARPENTER: 'Carpenter',
    ELECTRICIAN: 'Electrician',
    PLUMBER: 'Plumber',
    PLANT_OPERATOR: 'Plant operator',
    BRICKLAYER: 'Bricklayer',
    PLASTERER: 'Plasterer',
    SITE_MANAGER: 'Site Manager',
    HANDYMAN: 'Handyman',
    SCAFFOLDER: 'Scaffolder',
    MULTI_TRADE: 'Multi-Trade',
    PAINTER_DECORATOR: 'Painter / Decorator',
    GROUNDWORKER: 'Groundworker',
    WELDER: 'Welder',
    CONTRACTS_MANAGER: 'Contracts Manager',
    BANKSMAN: 'Banksman',
    TILER: 'Tiler',
    ASBESTOS_WORKER: 'Asbestos Worker',
    PROJECT_MANAGER: 'Project Manager',
    STEEL_FIXER: 'Steel Fixer',
    QUANTITY_SURVEYOR: 'Quantity Surveyor',
};

export const industryTypes = {
    GENERAL: 'IG',
    CLEANER: 'CL',
    WAREHOUSE: 'WH',
    PRODUCTION_LINE: 'PR',
    RAIL_GENERAL: 'RG',
    RAIL_SECURITY_OPERATIVE: 'RS',
    RAIL_CLEANER: 'RC',
    RAIL_DISPATCHER: 'RD',
    RAIL_CUSTOMER_SERVICE: 'RU',
    COMMERCIAL_GENERAL: 'CG'
};

export const industryRoles = {
    GENERAL: 'Industrial general',
    CLEANER: 'Cleaner',
    WAREHOUSE: 'Warehouse',
    PRODUCTION_LINE: 'Production Line',
    RAIL_GENERAL: 'Rail General',
    RAIL_SECURITY_OPERATIVE: 'Rail Security Operative',
    RAIL_CLEANER: 'Rail Cleaner',
    RAIL_DISPATCHER: 'Rail Dispatcher',
    RAIL_CUSTOMER_SERVICE: 'Rail Customer Service',
    COMMERCIAL_GENERAL: 'Commercial general'
};

export const hospitalityTypes = {
    BARBACK: 'BK',
    BARISTA: 'BT',
    BARTENDER: 'BM',
    FREELANCER: 'MX',
    KITCHEN_PORTERS: 'KP',
    WAITER: 'WA',
};

export const hospitalityRoles = {
    BARBACK: 'Chef',
    BARISTA: 'Barista',
    BARTENDER: 'Bartender',
    FREELANCER: 'General/Event staff',
    KITCHEN_PORTERS: 'Kitchen porter',
    WAITER: 'Waiter',
};

export const officeTypes = {
   OFFICE_GENERAL: 'CM',
   LEGAL: 'LG',
   PROCUREMENT: 'PR',
   ADMINISTRATOR: 'AD',
   RECEPTIONIST: 'RE',
   SALES: 'SA',
   CUSTOMER_SERVICE: 'CS',
   PAYROLL: 'PA',
   RECRUITMENT_CONSULTANT: 'RC',
   IT: 'IT',
   FINANCE: 'FN',
   QUALITY: 'QU',
   MARKETING: 'MA',
   HR: 'HR',
   PA_EA: 'PE',
   EXECUTIVES: 'EX',
   GRAPHIC_DESIGNER: 'GD',
   PROJECT_MANAGER: 'PM',
   CAD_TECHNICIAN: 'CT',
};

export const officeRoles = {
    TYPE_OFFICE_GENERAL: 'Office General',
    TYPE_LEGAL: 'Legal',
    TYPE_PROCUREMENT: 'Procurement',
    TYPE_ADMINISTRATOR: 'Administrator',
    TYPE_RECEPTIONIST: 'Receptionist',
    TYPE_SALES: 'Sales',
    TYPE_CUSTOMER_SERVICE: 'Customer Service',
    TYPE_PAYROLL: 'Payroll',
    TYPE_RECRUITMENT_CONSULTANT: 'Recruitment Consultant',
    TYPE_IT: 'IT',
    TYPE_FINANCE: 'Finance',
    TYPE_QUALITY: 'Quality',
    TYPE_MARKETING: 'Marketing',
    TYPE_HR: 'HR',
    TYPE_PA_EA: 'PA / EA',
    TYPE_EXECUTIVES: 'Executives',
    TYPE_GRAPHIC_DESIGNER: 'Graphic Designer',
    TYPE_PROJECT_MANAGER: 'Project Manager',
    TYPE_CAD_TECHNICIAN: 'CAD Technician',
};

export const deliverySizeLabels = {
    NONE: 'None',
    SMALL: 'Small',
    PIZZA: 'Pizza',
};

export const deliveryBox = 'delivery_box';

export const deliverySize = {
    NONE: 0,
    SMALL: 2,
    PIZZA: 4,
};

export const hospitalitySubRoles = {
    ACTIVE: 'active',
    FOOD_PREPARATION: 'food_preparation',
    COCKTAIL_MAKING: 'cocktail_making',
    SUPERVISOR: 'supervisor',
    SOUS_CHEF: 'sous_chef',
    COMMIS_CHEC: 'commis_chef',
    CHEF_DE_PARTIE: 'chef_de_partie',
    PASTRY_CHEF: 'pastry_chef',
};

export const vehicleSubRoles = {
    ACTIVE: 'active',
    OWN_VEHICLE: 'own_vehicle',
    MEDIUM_VAN: 'medium_van',
    LARGE_VAN: 'large_van',
    SIZE: 'size',
    ADR: 'adr',
    HIAB: 'hiab',
};

export const vanSizes = {
    MEDIUM_VAN: {
        value: 'medium_van',
        label: 'Medium',
    },
    LARGE_VAN: {
        value: 'large_van',
        label: 'Large / Giant',
    },
};

export const deliveryBoxSize = {
    NONE: {
        value: 0,
        label: 'We provide vehicle',
    },
    SMALL: {
        value: 2,
        label: 'Small box',
    },
    PIZZA: {
        value: 4,
        label: 'Pizza box',
    },
};

export const industrySubRoles = {
    ACTIVE: 'active',
    FORKLIFT_REACH: 'forklift_reach',
    FORKLIFT_COUNTERBALANCE: 'forklift_counterbalance',
};

export const freelancerRolesDetails = {
    [serviceTypes.CONSTRUCTION]: 'construction-roles',
    [serviceTypes.DRIVER]: 'vehicles',
    [serviceTypes.HOSPITALITY]: 'roles',
    [serviceTypes.INDUSTRY]: 'industry-roles',
    [serviceTypes.OFFICE]: 'office-roles',
};

export const MASS_BOOKING_MODE = 'mass-booking';
export const SERIES_BOOKING_MODE = 'series-booking';

export const NotificationType = {
    EMAIL_AND_PUSH: 'email_and_push',
    EMAIL_ONLY: 'email_only',
    PUSH_ONLY: 'push_only',
} as const;

export type TMatchingModeKeys = 'AUTO' | 'SEMI_AUTO' | 'MANUAL';

export const matchingModeLabels: {[key in TMatchingModeKeys]: string} = {
    AUTO: 'Auto',
    SEMI_AUTO: 'Semi-Auto',
    MANUAL: 'Manual',
};

export const matchingModeCodes: {[key in TMatchingModeKeys]: TMatchingMode} = {
    AUTO: 'MA',
    SEMI_AUTO: 'MS',
    MANUAL: 'MM',
};
